export interface Parcel {
    waybillNo: string;
    length: number;
    height: number;
    width: number;
    mass: number;
    parcelDescription: string | undefined;
    parcelNo: string | undefined;
    parcelCount: number;
}

export interface ParcelCapturePayload {
    waybillNo: string;
    length: number;
    height: number;
    width: number;
    mass: number;
    parcelDescription: string | undefined; // optional
    parcelNo: string | undefined;
    parcelCount: number;
}
export interface SundryCharge {
    Code: String
}


export interface SundryChargeType {
    name: string;
    code: string;
}

export const sundryChargeTypes: SundryChargeType[] = [
    {
        name: "B2C Surcharge",
        code: "B2C"
    },
    {
        name: "Fridgeline",
        code: "Z49"
    },
    {
        name: "Saturday AM",
        code: "D31"
    },
    {
        name: "Saturday PM",
        code: "D32"
    },
    {
        name: "Dawn Del",
        code: "03"
    },
    {
        name: "Consulates/Embassies",
        code: "35"
    },
    {
        name: "Tender",
        code: "36"
    },
    {
        name: "Aft Hrs 8pm to 7am",
        code: "26"
    },
    {
        name: "Aft Hrs 6pm to 8pm",
        code: "34"
    },
    {
        name: "Mine/Chain/Plot/Farm/Powerstation",
        code: "41"
    },
    {
        name: "INTERNATIONAL REGIONAL SU",
        code: "IR"
    },
    {
        name: "DEL/COLL SAT AM",
        code: "31"
    },
    {
        name: "SECURITY LEVY",
        code: "SL"
    },
    {
        name: "PERSONAL PROTECTIVE EQUIP",
        code: "PE"
    },
    {
        name: "FUEL S/CHARGE",
        code: "FU"
    },
    {
        name: "SECURITY LEVY",
        code: "SL"
    },
    {
        name: "DEL/COL SATPM SUN&PUBLIC",
        code: "33"
    },
    {
        name: "DOCUMENTATION FEE",
        code: "01"
    },
    {
        name: "INTERNATIONAL CURRENCY SU",
        code: "IC"
    },
    {
        name: "CONSIGNEE ONLY",
        code: "13"
    },
    {
        name: "DISBURSEMENTS",
        code: "DB"
    },
    {
        name: "TOWNSHIP SURCHARGE",
        code: "30"
    },
    {
        name: "INSURANCE",
        code: "IN"
    },
    {
        name: "AIR SURCHARGE",
        code: "AR"
    }
]


export enum Service {
    ONX = "ONX",
    ECON = "ECON"
}

export interface ServiceType {
    code: Service;
    name: string;
}

export const serviceTypes: ServiceType[] = [{
    name: "Overnight",
    code: Service.ONX,
},
{
    name: "Economy",
    code: Service.ECON,
}
]


export interface InstructionCode {
    code: string;
    name: string;
}

export const instructionCodes: InstructionCode[] = [
    {
        code: "INS1",
        name: "Instruction code 1"
    },
    {
        code: "INS2",
        name: "Instruction code 2"
    },
    {
        code: "INS3",
        name: "Instruction code 3"
    },
    {
        code: "INS4",
        name: "Instruction code 4"
    },
    {
        code: "INS5",
        name: "Instruction code 5"
    }
];
export enum StoreCode {
    JSON = "JSON"
}

export interface WaybillPayload {
    // Section 1 
    waybillNo: string; // required 
    sendAccNo: string; // required 
    sendSite: string | undefined; // optional 
    sendCompany: string; // required
    sendAdd1: string | undefined; // optional 
    sendAdd2: string; // required
    sendAdd3: string | undefined; // optional
    sendAdd4: string; // required
    sendAdd5: string; // required
    sendAdd6: string | undefined; // optional
    sendAdd7: string | undefined; // optional
    sendLongitude: string | undefined; // optional
    sendLatitude: string | undefined; // optional 
    sendW3w: string | undefined; // optional
    sendContactPerson: string | undefined; // optional 
    sendHomeTel: string | undefined; // optional
    sendWorkTel: string; // required
    sendCell: string | undefined; // optional

    // Section 2
    recCompany: string | undefined; // optional 
    recEmailAddress: string | undefined; // optional
    recAdd1: string | undefined; // optional
    recAdd2: string; // required
    recAdd3: string | undefined; // optional
    recAdd4: string; // required
    recAdd5: string; // optional
    recAdd6: string | undefined; // optional
    recAdd7: string | undefined; // optional
    recLongitude: string | undefined; // optional
    recLatitude: string | undefined; // optional
    recW3w: string | undefined; // optional
    recContactPerson: string; // required
    recHomeTel: string | undefined; // optional
    recWorkTel: string | undefined; // optional
    recCell: string; // required

    // Section 3
    specialInstructions: string | undefined; // optional
    serviceType: Service; // required
    totQTY: number | undefined; // optional
    totMass: number | undefined; // optional
    insurance: boolean | undefined; // optional
    insuranceValue: number | undefined; // optional
    customerRef: string | undefined; // optional
    storeCode: StoreCode | undefined; // optional
    securityStamp: string | null | undefined; // optional
    requiredDocs: string[] | undefined; // optional

    // Section 4 
    waybillInstructions: string[] | undefined // optional;
    instructionCode: string | undefined; // optional;
    isSecureDelivery: boolean | undefined; // required
    verificationNumbers: string | undefined; // optional
    generateSecurePin: boolean | undefined; // required
    collectionNo: string | undefined; // optional
    invoiceRef: string | undefined; // optional
    Misc: string | undefined; // optional

    // Section 5
    parcels: Parcel[]; // required
    documents: string[] | undefined; // optional
    completeWaybillAfterSave: boolean; // optional
    generateLabel: boolean | undefined; // optional
    bookedDate: string | undefined; // optional
    SundryCharges: SundryCharge[] | undefined; // optional
}


export interface WaybillCompletePayload {
    waybillNo: string;
    storeCode: string;
    securityStamp: string;
    generateLabel: number;
}

export interface PrintDeliveryLabelPayload {
    waybillNumber: string | undefined |null;
    address_1: string | undefined;
    address_2: string | undefined;
    building_apt_number: string | undefined;
    city: string | undefined;
    province: string | undefined;
    postcode: string | undefined;
    country: string | undefined;
}

export interface WaybillOrderData {
    waybillNumber: string | undefined |null;
    order_number: number | undefined;
    customer_order_number: string | undefined;
    company_name: string | undefined;
    product: string | undefined;
    total_quantity: number | undefined;
    date_shiped: string | undefined;
}

export interface WaybillOrderApiResponse {
    success: boolean;
    message: string;
    data: WaybillOrderData[]; // Array of ShippingDetail
    errors: any; // Adjust based on expected error structure (could be null or an object)
}